import { useSyncExternalStore } from "react";

// Server-provided capability flags and contact info. Loaded once at app
// startup; falls back to empty defaults so the UI never blocks on it.

export interface AppConfig {
  support_email: string;
  email_available: boolean;
}

const EMPTY: AppConfig = { support_email: "", email_available: false };

let config: AppConfig = EMPTY;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function snapshot(): AppConfig {
  return config;
}

export function useConfig(): AppConfig {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}

export async function loadConfig(): Promise<void> {
  try {
    const res = await fetch("/api/config", { credentials: "same-origin" });
    if (!res.ok) return;
    const body = (await res.json()) as Partial<AppConfig>;
    config = {
      support_email:
        typeof body.support_email === "string" ? body.support_email : "",
      email_available: body.email_available === true,
    };
    listeners.forEach((l) => l());
  } catch {
    /* leave defaults — UI works without it */
  }
}
